/* Redux */
import { useSelector, useDispatch } from 'src/redux/hooks'
import { shallowEqual } from 'react-redux'

/* Types */
import { tFilterType } from 'src/redux/reducers/filter'

const Redux = () => {
  const dispatch = useDispatch()

  const { 
    filterTree, activeFilters,
    filterBrands, activeBrands,
  } = useSelector(store => ({
    filterTree: store.Filter.filterTree,
    activeFilters: store.Filter.activeFilters,
    filterBrands: store.Filter.filterBrands,
    activeBrands: store.Filter.activeBrands,
  }), shallowEqual)

  const changeFilter = (
    type: tFilterType,
    toggle: boolean,
    filter: number,
    option: number
  ) =>
    dispatch({
      type: toggle ? 'setFilterOption' : 'unsetFilterOption',
      payload: { type, toggle, filter, option },
    })

  const toggleBrand = (toggle:boolean, id:number) =>
    dispatch({
      type: toggle ? 'setBrand' : 'unsetBrand',
      payload: id,
    })

  return { 
    filterTree, activeFilters, changeFilter,
    filterBrands, activeBrands, toggleBrand,
  }
}

export default Redux
